import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../Globals/styles';
import WheelInput from '../../Common/wheelInput'
import Waves from 'node-waves'

class ActivityTableItem extends Component{
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isEditing: false
    }
  }
  toggleOpen = () => {
    var isOpen =  this.state.isOpen;
    this.setState({
      isOpen: !isOpen,
      isEditing: false
    });
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  calcSum = (items, key) => {
    var res = 0;
    items.forEach(item=>{res += parseFloat(item[key])})
    return res;
  };
  getArrowClass = () => {
    return this.state.isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
  };
  toggleEditing = () => {
    var isEditing =  this.state.isEditing;
    this.setState({
      isEditing: !isEditing
    });
  };
  editSubActivities = () => {
    if (this.refs.addActivityInputField.value.replace(/^\s+|\s+$/g, "").length > 0){
      this.props.addNewActivity(this.refs.addActivityInputField.value, this.props.id)
      this.refs.addActivityInputField.value = "";
    }
    var changedNames = [];
    this.props.childItems.forEach((child) => {
      if (this.refs[child.id].value.replace(/^\s+|\s+$/g, "").length > 0)
        changedNames.push({id: child.id, name: this.refs[child.id].value, oldName: child.name})
    });
    if (changedNames.length > 0) this.props.renameActivities(changedNames)

    this.setState({
      isEditing: false
    });
  };
  editActivitiy = (id) => {
    if (this.refs[id].value.replace(/^\s+|\s+$/g, "").length > 0)
      this.props.renameActivities([{id: id, name: this.refs[id].value, oldName: this.props.name}])
    this.setState({
      isEditing: false
    });
  };
  renderWithChild = () => {
    const {name, childItems } = this.props;
    var todaysHrs = this.calcSum(childItems, "todaysHrs");
    return ( <div>
                <div style={[styles.activityItem]}>
                <div className="col-xs-6 waves-btn" style={styles.fixRows}  onClick={this.toggleOpen}>
                    <div style={[styles.parentHeading, styles.heading, styles.pointer]} className="col-xs-10">
                      {name}
                    </div>
                    <div style={[styles.pointer, styles.chevron]} className="col-xs-2 text-center">
                      <i className={this.getArrowClass()}></i>
                    </div>
                  </div>
                  <div className="col-xs-4 text-center">
                    {todaysHrs}
                  </div>
                  <div style={styles.editIconContainer} className="col-xs-2 text-right">
                    {this.state.isEditing ?
                      <i
                        onClick={this.editSubActivities}
                        style={styles.floppyIcon}
                        className="fa fa-floppy-o waves-icon"></i> : null
                      }
                    {this.state.isOpen ?
                        <i  style={[this.state.isEditing && styles.editIconActive,styles.fixIcons]}
                            onClick={this.toggleEditing}
                            className="fa fa-pencil waves-icon">
                        </i> : null}
                  </div>
                </div>
                {this.state.isEditing ?
                  <div style={[styles.childItem]}>
                    <div className="col-xs-5">
                      <input
                        ref="addActivityInputField"
                        style={styles.addActivityInputField}
                        placeholder="Tilføj aktivitet..."/>
                    </div>
                  </div>
                  :
                  null
                }
                  {this.renderChildren()}

              </div>
              )
  };
  renderChildren = () => {
    if (!this.state.isOpen) return null;
    const { childItems, onActivityChange, hoursPool, hoursRegistered } = this.props;
    var childItemsList = childItems.map((child)=> {
        return  (
            <div key={child.id} style={[styles.childItem]}>
              {/*In edit mode ?*/}
              {this.state.isEditing ?
              /*In edit mode*/
              <div>
                <div className="col-xs-5">
                    <input
                      ref={child.id}
                      style={[styles.addActivityInputField, styles.addActivityInputFieldChild]}
                      placeholder={child.name}/>
                </div>
                <div className="col-xs-6 text-center">
                   {parseFloat(child.todaysHrs)}
                </div>
              </div>
              :
              /*Not in edit mode*/
              <div>
                <div style={styles.heading} className="col-xs-4">
                    {child.name}
                </div>
                <div className="col-xs-6 col-xs-offset-1">
                   <WheelInput
                      maxValue={hoursPool}
                      minValue={0}
                      interval={0.5}
                      defaultValue={parseFloat(child.todaysHrs)}
                      onChange={(value)=>{onActivityChange(child.id, value, child.todaysHrs)}}
                      maxSelectionValue={hoursPool-hoursRegistered}
                      overLayColor="linear-gradient(to right, rgba(230,238,240,1) 2%,rgba(230,238,240,1) 6%,rgba(230,238,240,0) 50%,rgba(230,238,240,1) 92%,rgba(230,238,240,1) 200%)"
                    />
                </div>
              </div>
              }
            </div>


      )
    });
    return (<div>{childItemsList}</div>);
  };
  renderWithoutChild = () => {
    const {name, todaysHrs, haveBorder, onActivityChange, id, hoursPool, hoursRegistered } = this.props;
    return (
            <div key={id} style={[styles.activityItem, haveBorder && styles.noBorder]}>
              {this.state.isEditing ?
              /*In edit mode*/
              <div>
                <div className="col-xs-6" style={styles.parentInputContainer}>
                    <input
                      ref={id}
                      style={styles.addActivityInputField}
                      placeholder={name}/>
                </div>
                <div className="col-xs-4 text-center">
                   {parseFloat(todaysHrs)}
                </div>
                <div style={styles.editIconContainer} className="col-xs-2 text-right">
                  {this.state.isEditing ? <i onClick={()=>{this.editActivitiy(id)}} style={styles.floppyIcon} className="fa fa-floppy-o waves-icon"></i> : null}
                  <i style={styles.editIconActive} onClick={this.toggleEditing} className="fa fa-pencil waves-icon"></i>
                </div>
              </div>
              :
              <div>
                <div style={[styles.parentHeading, styles.heading]} className="col-xs-6">
                  {name}
                </div>
                <div className="col-xs-4">
                    <WheelInput
                      maxValue={hoursPool}
                      minValue={0}
                      interval={0.5}
                      defaultValue={todaysHrs}
                      onChange={(value)=>{onActivityChange(id, value, todaysHrs)}}
                      maxSelectionValue={hoursPool-hoursRegistered}
                      />
                </div>
                <div style={styles.editIconContainer} className="col-xs-2 text-right">
                  <i onClick={this.toggleEditing} style={styles.fixIcons} className="fa fa-pencil waves-icon"></i>
                </div>
              </div>
              }
            </div>
           )
  };

  render()  {
    const { childItems } = this.props;
    return (
      <div>
        {childItems ? this.renderWithChild() : this.renderWithoutChild()}
      </div>
    );
  }
}

var styles = {
  activityItem: {
    height: '42px',
    borderBottom: '1px solid ' + greyScaleColors.greyLighter,
    lineHeight: "40px",
    width: '100%'
  },
  noBorder: {
    borderBottom: 'none'
  },
  childItem: {
    height: '41px',
    lineHeight: "39px",
    width: '100%',
    backgroundColor: semanticColors.infoLighter,
    borderBottom: '1px solid ' + greyScaleColors.greyLighter
  },
  input: {
    paddingTop: '5px'
  },
  heading:{
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: '600',
    paddingRight: '0'
  },
  parentHeading:{
    fontSize: '16px',
    paddingLeft: '0'
  },
  parentInputContainer: {
    padding: '0'
  },
  editIconContainer:{
    position: 'relative',
    fontSize: '20px',
    cursor: 'pointer',
    height: '40px',
    lineHeight: '40px'
  },
  floppyIcon: {
    position: 'absolute',
    top: '6px',
    left: '10px',
    height:'30px',
    width: '30px',
    lineHeight: '30px'
  },
  editIconActive: {
    color: semanticColors.info,
    height:'30px',
    width: '30px',
    lineHeight: '30px',
    overflow: 'initial'
  },
  addActivityInputField: {
    height: '40px',
    border: '0',
    paddingLeft: '6px',
    borderRadius: '2px',
    width: '100%'
  },
  addActivityInputFieldChild: {
    height: '39px'
  },
  pointer: {
    cursor: 'pointer'
  },
  chevron:{
    float: 'right'
  },
  fixRows:{
    padding: '0px',
    lineHeight: '40px',
    textAlign: 'left'
  },
  fixIcons: {
    height: '30px',
    width: '30px',
    lineHeight: '30px',
    overflow:'initial'
  }
}
  PropTypes.propTypes = {
    haveBorder: PropTypes.bool,
    childItems: PropTypes.array,
    hoursPool: PropTypes.number.isRequired,
    hoursRegistered: PropTypes.number.isRequired,
    addNewActivity: PropTypes.func.isRequired,
    renameActivities: PropTypes.func.isRequired
  };
export default Radium(ActivityTableItem);


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/activityTableItem.jsx